import { Modal } from "UI/molecules/index";

import { Button, Error, Input, Select } from "UI/atoms/index";

import Close from "shared/images/xcircle.svg";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import checkIcon from "shared/images/check2.svg";

import { validatorAssosiation } from "../utils/validatorSchemas";
import { useGetSettings } from "pages/Settings/queries/settings";
import { useEffect } from "react";
import { useGetData } from "shared/queries/commons";

const ModalAssociation = ({
  isOpenModal,
  setIsOpenModal,
  title,
  addItem,
  onSuccesToast,
  closeModal,
  itemToEdit,
  editItem,
  setSelectItemId,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setError,
    setValue,
  } = useForm({
    defaultValues: {
      name: "",
      location: "",
      community: "",
      warehouse: "",
    },
    resolver: yupResolver(validatorAssosiation),
  });

  const { data: communities } = useGetSettings("communities");
  const { data: location } = useGetSettings("locations");
  const { data: warehouses } = useGetData("warehouses", "warehouses");

  const submitItem = (e, action) => {
    e.preventDefault();

    switch (action) {
      case "add":
        handleSubmit((data) => {
          addItem(data, {
            onError: (err) => {
              const error = JSON.parse(err.response.request.responseText);

              if (error) {
                return setError("name", {
                  type: "error",
                  message: "El nombre ingresado ya existe",
                });
              }
            },
            onSuccess: () => {
              onSuccesToast("success", "Item agregado con éxito");
              setSelectItemId("");
              reset();
            },
          });
        })();
        break;
      case "edit":
        handleSubmit((data) => {
          editItem(data, {
            onError: (err) => {
              const error = JSON.parse(err.response.request.responseText);

              if (error) {
                return setError("name", {
                  type: "error",
                  message: "El nombre ingresado ya existe",
                });
              }
            },
            onSuccess: () => {
              onSuccesToast("success", "Item editado con éxito");
              setSelectItemId("");
              reset();
            },
          });
        })();
        break;
      default:
        console.log("Default");
    }
  };

  useEffect(() => {
    if (itemToEdit) {
      setValue("name", itemToEdit?.name);
      setValue("location", itemToEdit?.location?.id);
      setValue("community", itemToEdit?.community?.id);
      setValue("warehouse", itemToEdit?.warehouse?.id);
    }
  }, [itemToEdit, setValue]);

  return (
    <Modal
      isOpen={isOpenModal}
      toggleModal={setIsOpenModal}
      width="600px"
      padding="34px 38px"
      className="modal-ajustes"
    >
      <div className="modal-head">
        <h1>{title}</h1>
        <Button width="40px" height="40px">
          <img src={Close} onClick={closeModal} alt="Cerrar modal" />
        </Button>
      </div>

      <form
        className="ajustes-fields"
        onSubmit={(e) =>
          submitItem(e, itemToEdit.length === 0 ? "add" : "edit")
        }
      >
        <div className="row">
          <div className="field">
            <label>Nombre</label>
            <Input
              placeholder="Nombre"
              type="text"
              name="email"
              border="1px solid #908892"
              {...register("name")}
            />
          </div>
          <Error>{errors.name?.message}</Error>
        </div>

        <div className="row">
          <div className="field">
            <label>Ubicación</label>
            <Select
              placeholder="Ubicacion"
              type="text"
              name="email"
              border="1px solid #908892"
              {...register("location")}
            >
              <option value={""}>Selecciona una ubicación</option>
              {location?.map((loc) => (
                <option key={loc.id} value={loc.id}>
                  {loc.name}
                </option>
              ))}
            </Select>
          </div>
        </div>

        <div className="row">
          <div className="field">
            <label>Zona</label>
            <Select
              readOnly
              placeholder="Ubicacion"
              type="text"
              name="email"
              border="1px solid #908892"
              {...register("community")}
            >
              <option value={""}>Selecciona una zona</option>
              {communities?.map((com) => (
                <option key={com.id} value={com.id}>
                  {com.name}
                </option>
              ))}
            </Select>
            <Error>{errors.community?.message}</Error>
          </div>
        </div>

        <div className="row">
          <div className="field">
            <label>Deposito</label>
            <Select
              placeholder="Ubicacion"
              type="text"
              name="email"
              border="1px solid #908892"
              {...register("warehouse")}
            >
              <option value={""}>Selecciona un depoosito</option>
              {warehouses?.map((wer) => (
                <option key={wer.id} value={wer.id}>
                  {wer.name}
                </option>
              ))}
            </Select>
            <Error>{errors.warehouse?.message}</Error>
          </div>
        </div>

        <div className="actions">
          <Button
            background="#413A44"
            color="white"
            width="140px"
            height="44px"
            fontSize="1.4em"
            className="action-btn"
            fontWeight="400"
          >
            <img src={checkIcon} width="18" alt="Guardar cambios" />
            Confirmar
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export { ModalAssociation };
